import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from 'services/Auth';

class CompanyDocumentApi extends Api {
  constructor() {
    super('admin/company_documents/');
  }

  getExcel = (params) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/admin/company_documents.xlsx`,
      method: 'get',
      data: params.data,
      params: params.params,
      responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        ...(params?.headers || {}),
        'auth-token': AuthService.getToken(),
      },
    });
  };
  getPDF(url) {
    return axios({
      url,
      method: 'get',
      data: {},
      params: {},
      responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  }
}

export default CompanyDocumentApi;
